import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import * as DownloadOverlayActions from './DownloadOverlayActions';
import DownloadOverlay from './containers/DownloadOverlay';
import store from '../store';

const mapStateToProps = state => (
  {
    show: state.DownloadOverlayHandler.show,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...DownloadOverlayActions,
  }, dispatch)
);

const ConnectedDownloadOverlayContainer = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(DownloadOverlay);

export default class DownloadOverlayContainer extends DownloadOverlay {
  static init(id, props) {
    ReactDOM.render(
      <ReactRedux.Provider store={store}>
        <div>
          <ConnectedDownloadOverlayContainer {...props} />
        </div>
      </ReactRedux.Provider>,
      document.getElementById(id),
    );
  }
}

if (window.FormSwift && window.FormSwift.React) {
  const addedActions = Object.assign(
    {},
    DownloadOverlayActions,
    window.FormSwift.React.actions,
  );
  window.FormSwift.React.actions = addedActions;
} else {
  window.FormSwift = {
    React: {
      store,
      actions: DownloadOverlayActions,
    },
  };
}



// WEBPACK FOOTER //
// ./src-react/download-overlay/index.jsx